import { createSlice } from "@reduxjs/toolkit";
import { STATUS } from "../constant";

const initialState = {
	prePayment: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	selectProduct: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	promotion: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	checkout: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
};

export const paymentSlice = createSlice({
	name: "payment",
	initialState,
	reducers: {
		fetchPrePaymentData(state, _action) {
			state.prePayment.status = STATUS.REQUEST;
			state.prePayment.data = (state.prePayment.data ?? null) as any;
			state.prePayment.error = null;
		},
		fetchPrePaymentDataSuccess(state, action) {
			state.prePayment.status = STATUS.SUCCESS;
			state.prePayment.data = action.payload.data;
			state.prePayment.error = null;
		},
		fetchPrePaymentDataFailure(state, action) {
			state.prePayment.status = STATUS.FAILED;
			state.prePayment.data = null;
			state.prePayment.error = action.payload.error;
		},
		selectProduct(state, _action) {
			state.selectProduct.status = STATUS.REQUEST;
			state.selectProduct.data = null;
			state.selectProduct.error = null;
		},
		selectProductSuccess(state, action) {
			state.selectProduct.data = action.payload.data;
			state.selectProduct.error = null;
			state.selectProduct.status = STATUS.SUCCESS;
		},
		selectProductFailure(state, action) {
			state.selectProduct.data = null;
			state.selectProduct.error = action.payload.error;
			state.selectProduct.status = STATUS.FAILED;
		},
		applyPromotion(state, _action) {
			state.promotion.status = STATUS.REQUEST;
			state.promotion.data = null;
			state.promotion.error = null;
		},
		applyPromotionSuccess(state, action) {
			state.promotion.data = action.payload.data;
			state.promotion.error = null;
			state.promotion.status = STATUS.SUCCESS;
		},
		applyPromotionFailure(state, action) {
			state.promotion.data = null;
			state.promotion.error = action.payload.error;
			state.promotion.status = STATUS.FAILED;
		},
		proceedPayment(state, _action) {
			state.checkout.status = STATUS.REQUEST;
			state.checkout.data = null;
			state.checkout.error = null;
		},
		proceedPaymentSuccess(state, action) {
			state.checkout.data = action.payload.data;
			state.checkout.error = null;
			state.checkout.status = STATUS.SUCCESS;
		},
		proceedPaymentFailure(state, action) {
			state.checkout.data = null;
			state.checkout.error = action.payload.error;
			state.checkout.status = STATUS.FAILED;
		},
		triggerCancel() {
			return initialState;
		},
		resetSelectProduct(state) {
			state.selectProduct = initialState.selectProduct;
		},
		resetPromotion(state) {
			state.promotion = initialState.promotion;
		},
	},
});

export const {
	fetchPrePaymentData,
	fetchPrePaymentDataSuccess,
	fetchPrePaymentDataFailure,
	selectProduct,
	selectProductSuccess,
	selectProductFailure,
	applyPromotion,
	applyPromotionSuccess,
	applyPromotionFailure,
	proceedPayment,
	proceedPaymentSuccess,
	proceedPaymentFailure,
	triggerCancel,
	resetSelectProduct,
	resetPromotion,
} = paymentSlice.actions;

export default paymentSlice.reducer;
